// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JH8x","title":"styles_title__25Wrp"};